import { SeverityType } from '../constants/severity-type.const';

export class Message {
    constructor(content: string, severityType: SeverityType) {
        this.content = content;
        this.severityType = severityType;
    }
    content: string;
    severityType: SeverityType;
}
